import { useQuery } from "@apollo/client";
import { GET_TRADE_CONTEXT } from "../graphql/trade-context";
import { TradeContext } from "../types/tradeContext";

export const useTradeContext = (tradeId?: number | null) => {
  const skip = tradeId == null;
  const { data, loading, error, refetch } = useQuery<
    { getTradeContext: TradeContext },
    { tradeId: number }
  >(GET_TRADE_CONTEXT, {
    skip,
    variables: skip ? undefined : { tradeId: tradeId as number },
    fetchPolicy: "cache-and-network",
  });

  return {
    tradeContext: data?.getTradeContext ?? null,
    loading,
    error,
    refetch,
  };
};
